import { siloRepositoryAbi } from "@silo/contract-abi-types";
import { siloRepositoryAddress } from "@silo/contract-addresses";
import {
  Address,
  ChainPublicClientService,
  ProtocolKeyService,
} from "@silo/types";
import { Effect, pipe } from "effect";
import { getContract } from "viem";
import { ContractsClientError } from "./types";
import { Schema } from "@effect/schema";

export type GetRouterAddress = ReturnType<typeof getRouterAddress>;
export type GetRouterAddressSuccess = Effect.Effect.Success<GetRouterAddress>;
export type GetRouterAddressError = Effect.Effect.Error<GetRouterAddress>;
export type GetRouterAddressContext = Effect.Effect.Context<GetRouterAddress>;

export function getRouterAddress() {
  return Effect.gen(function* () {
    const { publicClient } = yield* ChainPublicClientService;
    const protocolKey = yield* ProtocolKeyService;

    const siloRepositoryContract = getContract({
      address: siloRepositoryAddress[protocolKey],
      abi: siloRepositoryAbi,
      client: publicClient,
    });

    const routerAddress = yield* pipe(
      Effect.tryPromise({
        try: async () => {
          return siloRepositoryContract.read.router();
        },
        catch: (cause) => new ContractsClientError({ cause }),
      }),
      Effect.andThen(Schema.decode(Address))
    );

    return routerAddress;
  });
}
